export var abs = Math.abs;
export var asin = Math.asin;
export var floor = Math.floor;
export var cos = Math.cos;
export var pow = Math.pow;
export var sin = Math.sin;
export var sqrt = Math.sqrt;
